import { Navigate, useLocation } from "react-router-dom";
import { PageRoutes } from "../constants/historyGaming";
import { useAppSelector } from "../components/hooks";
import { selectIsAuthenticated, selectAuthStatus, UserState } from "@onmo/auth";
import { useQuery } from "@apollo/client";
import { meGQL } from "@onmo/graphql/graphql";

interface RoutesWrapperProps {
  children: React.ReactNode;
}

const RoutesWrapper: React.FC<RoutesWrapperProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const state = useAppSelector(selectAuthStatus);
  const { data: dataMe, loading: loadingMe } = useQuery(meGQL);

  const at = (p: string) => location.pathname.startsWith(p);
  const hasOnboarded = localStorage.getItem("hasOnboarded") === "true";

  if (!hasOnboarded && !at(PageRoutes.Onboarding) && !isAuthenticated) {
    return <Navigate to={PageRoutes.Onboarding} replace />;
  }

  if (hasOnboarded && !at(PageRoutes.Guest) && !isAuthenticated)
    return <Navigate to={PageRoutes.Guest} replace />;

  if (
    isAuthenticated &&
    !loadingMe &&
    dataMe?.me?.metadata &&
    !JSON.parse(dataMe.me.metadata.onboarding || "{}")
      .hasCheckedUserNameAvatar &&
    !at(PageRoutes.SetProfile)
  ) {
    return <Navigate to={PageRoutes.SetProfile} replace />;
  }

  return <>{children}</>;
};

export default RoutesWrapper;
